import {createContext} from 'react'
const MusicianContext = createContext({})
export const MusicianProvider = MusicianContext.Provider
export default MusicianContext